import m from 'mithril'
import * as currency from '@shopify/theme-currency'
import { events, states, addCartItem } from '../components/state'

const Select = {
  view: vnode => {
    const {
      defaultOptionText,
      defaultOption,
      minValue,
      maxValue,
      interval,
      name,
      suffix,
      fullWidth,
      setPrescriptionDetailValue,
      testPrescriptionValidity,
      placeholderText
    } = vnode.attrs

    let options = []
    let selectedOption = placeholderText

    for (let i = minValue; i <= maxValue; i += interval) {
      options.push(`${i}${suffix ? suffix : ''}`)
    }

    // If customer don't know their prescription detail. ex. I don't know
    if (defaultOption) {
      options = [defaultOptionText, ...options]
    }

    if (minValue < 0) {
      options.splice(Math.floor(options.length / 2), 0, selectedOption)
    } else {
      options.splice(0, 0, selectedOption)
    }

    function onChange(event) {
      let value = event.target.value
      setPrescriptionDetailValue(name, value)
      testPrescriptionValidity()
    }

    return (
      <div className={`select-styled ${fullWidth ? 'select-styledFull' : ''}`}>
        <select name={name} required onchange={event => onChange(event)}>
          {options.map(option => {
            let isSelected = option === selectedOption
            return <option value={option}
              disabled={isSelected}
              selected={isSelected}>{option}</option>
          })}
        </select>
      </div>
    )
  }
}

const PrescriptionToggleButton = {
  view: vnode => {
    const { events, colour, context, activeProductId, activeProductPreAvail, activeProductAvail, activeProductPrice, activeProductSalePrice } = vnode.attrs
    const { setPrescriptionStep } = events
    const { addToCartText, soldOutText, preorderText } = context

    if (activeProductAvail) {
      return (
        <a className={`productBlock_button button button-block button-${colour || 'green'}`} href="#"
            onclick={event => {
              event.preventDefault()
              setPrescriptionStep(1)
            }}>{activeProductPreAvail ? preorderText : addToCartText}</a>
      )
    } else {
      return (
        <a className="productBlock_button button button-block button-disabled" href="#"
           onclick={event => {
             event.preventDefault()
           }}>{soldOutText}</a>
      )
    }
  }
}

const AddToCartButton = {
  view: vnode => {
    const { addCartItem, disabled, selectedOption, buttonText } = vnode.attrs
    const isDisabled = typeof disabled !== 'undefined' && disabled

    return (
      <a className={`button button-block button-large button-${isDisabled ? 'disabled' : 'green'}`}
        href="#"
        onclick={event => {
        event.preventDefault()
        if (!isDisabled) {
          addCartItem(selectedOption.id, 1)
        }
      }}>
        {buttonText}
      </a>
    )
  }
}

const PrescriptionButton = {
  view: vnode => {
    const { nextStep, buttonText } = vnode.attrs

    return (
      <a className="button button-block button-large"
        style="width: fit-content;
        margin: 0 auto;
        display: inherit;
        padding: 0 25px;"
        href="#"
        onclick={event => {
        event.preventDefault()
        nextStep()}}
      >
        {buttonText} &rarr;
      </a>
    )
  }
}

const PrescriptionSelector = {
  view: vnode => {
    const { events, context, state, moneyFormat, product } = vnode.attrs
    const { Prescription } = context
    const { addCartItem,
      setPrescriptionStep,
      setPrescriptionDetailValue,
      setSelectedOption,
      testPrescriptionValidity,
      togglePolarised
    } = events
    const { prescriptionStep, prescriptionValidity, prescriptionDetails, selectedOption, isPolarised } = state
    const { id, name, type, title, price, compare_at_price } = product
    let { productOptions } = vnode.attrs
    const closeIcon = Shopify.Icons.Close

    // Spread on translations object
    const { Button, Form, Label, Options, Support } = Prescription

    if (!selectedOption) {
      setSelectedOption(productOptions[0])
    }

    function previousStep() {
      setPrescriptionStep(prescriptionStep - 1)
    }

    function nextStep() {
      setPrescriptionStep(prescriptionStep + 1)
    }

    function togglePolarisedOption() {
      if (isPolarised) {
        togglePolarised(true)
        setSelectedOption(productOptions[0])
      } else {
        togglePolarised(false)
        setSelectedOption(productOptions[1])
      }
    }

    if (prescriptionStep > 0) {
      return (
        <div className="prescriptionPopup">
          <div className="prescriptionPopup_container">

            <div className="prescriptionPopup_close" onclick={event => {
              event.preventDefault()
              setPrescriptionStep(0)
            }}>
              <img class="icon icon_close" src={closeIcon} />
            </div>

            <div className="prescriptionPopup_productTitle">
              <div className="prescriptionPopup_productTitle-model">{name.split(' - ')[0]}</div>
              <div className="prescriptionPopup_productTitle-colour">{title.split(' / ')[0]}</div>
            </div>

            {prescriptionStep === 1 ?
              <div className="prescriptionPopup_optionsContainer">

                <div className="prescriptionPopup_options">
                  <div className="prescriptionPopup_optionsTitle">{Label.Addons}</div>
                  <div
                    className={`prescriptionPopup_option ${isPolarised ? 'prescriptionPopup_option-selected' : ''}`}
                    onclick={event => {
                      event.preventDefault()
                      togglePolarisedOption()
                    }}>
                    <div className="prescriptionPopup_optionCheckmark"></div>
                    <h6 className="prescriptionPopup_optionTitle">{productOptions[1].title.split(' / ')[1]}</h6>
                    <div className="prescriptionPopup_optionPrice">
                      + {currency.formatMoney((productOptions[1].price - productOptions[0].price), moneyFormat)}
                    </div>
                  </div>

                  <div className="prescriptionPopup_optionsTitle prescriptionPopup_optionsTitle-extra">{Label.AlwaysIncluded}</div>
                  <div className="prescriptionPopup_option prescriptionPopup_option-included">
                    <h6 className="prescriptionPopup_optionTitle">{Options.Option1.Title}</h6>
                    <div className="prescriptionPopup_optionPrice">{Options.Option1.Price}</div>
                  </div>

                  <div className="prescriptionPopup_option prescriptionPopup_option-included">
                    <h6 className="prescriptionPopup_optionTitle">{Options.Option2.Title}</h6>
                    <div className="prescriptionPopup_optionPrice">{Options.Option2.Price}</div>
                  </div>
                </div>

                <PrescriptionButton
                  buttonText={Button.EnterDetailsText}
                  nextStep={nextStep}
                />
              </div> : ''
            }

            {prescriptionStep === 2 ?
              <div className="prescriptionPopup_optionsContainer">

                <div className="prescriptionPopup_description">{Support.HelpText}</div>

                <div className="prescriptionPopup_enterDetails">
                  <div className="prescriptionPopup_headerLabels">
                    <div className="prescriptionPopup_headerLabel">{Form.Label.RightEye}</div>
                    <div className="prescriptionPopup_headerLabel">{Form.Label.LeftEye}</div>
                  </div>

                  {/* Sphere */}
                  <div className="prescriptionPopup_formGroup">
                    <label className="prescriptionPopup_formlabel">{Form.Label.Sphere}</label>
                    <div className="prescriptionPopup_selectGroup">
                      <Select
                        defaultOptionText={Form.DefaultOption}
                        defaultOption={false}
                        minValue={-4}
                        maxValue={4}
                        interval={0.25}
                        name={'sphereRight'}
                        suffix={null}
                        fullWidth={false}
                        setPrescriptionDetailValue={setPrescriptionDetailValue}
                        testPrescriptionValidity={testPrescriptionValidity}
                        placeholderText={Form.SelectPlaceholder}
                      />
                      <Select
                        defaultOptionText={Form.DefaultOption}
                        defaultOption={false}
                        minValue={-4}
                        maxValue={4}
                        interval={0.25}
                        name={'sphereLeft'}
                        suffix={null}
                        fullWidth={false}
                        setPrescriptionDetailValue={setPrescriptionDetailValue}
                        testPrescriptionValidity={testPrescriptionValidity}
                        placeholderText={Form.SelectPlaceholder}
                      />
                    </div>
                  </div>

                  {/* Cylinder */}
                  <div className="prescriptionPopup_formGroup">
                    <label className="prescriptionPopup_formlabel">{Form.Label.Cylinder}</label>
                    <div className="prescriptionPopup_selectGroup">
                      <Select
                        defaultOptionText={Form.DefaultOption}
                        defaultOption={false}
                        minValue={-2}
                        maxValue={2}
                        interval={0.25}
                        name={'cylinderRight'}
                        suffix={null}
                        fullWidth={false}
                        setPrescriptionDetailValue={setPrescriptionDetailValue}
                        testPrescriptionValidity={testPrescriptionValidity}
                        placeholderText={Form.SelectPlaceholder}
                      />
                      <Select
                        defaultOptionText={Form.DefaultOption}
                        defaultOption={false}
                        minValue={-2}
                        maxValue={2}
                        interval={0.25}
                        name={'cylinderLeft'}
                        suffix={null}
                        fullWidth={false}
                        setPrescriptionDetailValue={setPrescriptionDetailValue}
                        testPrescriptionValidity={testPrescriptionValidity}
                        placeholderText={Form.SelectPlaceholder}
                      />
                    </div>
                  </div>

                  {/* Axis */}
                  <div className="prescriptionPopup_formGroup">
                    <label className="prescriptionPopup_formlabel">{Form.Label.Axis}</label>
                    <div className="prescriptionPopup_selectGroup">
                      <Select
                        defaultOptionText={Form.DefaultOption}
                        defaultOption={false}
                        minValue={0}
                        maxValue={179}
                        interval={1}
                        name={'axisRight'}
                        suffix={'°'}
                        fullWidth={false}
                        setPrescriptionDetailValue={setPrescriptionDetailValue}
                        testPrescriptionValidity={testPrescriptionValidity}
                        placeholderText={Form.SelectPlaceholder}
                      />
                      <Select
                        defaultOptionText={Form.DefaultOption}
                        defaultOption={false}
                        minValue={0}
                        maxValue={179}
                        interval={1}
                        name={'axisLeft'}
                        suffix={'°'}
                        fullWidth={false}
                        setPrescriptionDetailValue={setPrescriptionDetailValue}
                        testPrescriptionValidity={testPrescriptionValidity}
                        placeholderText={Form.SelectPlaceholder}
                      />
                    </div>
                  </div>

                  {/* Pupillary distance */}
                  <div className="prescriptionPopup_formGroup">
                    <label className="prescriptionPopup_formlabel">{Form.Label.PupillaryDistance}</label>
                    <div className="prescriptionPopup_selectGroup">
                      <Select
                        defaultOptionText={Form.DefaultOption}
                        defaultOption={true}
                        minValue={25}
                        maxValue={45}
                        interval={0.5}
                        name={'pupillaryDistanceRight'}
                        suffix={null}
                        fullWidth={false}
                        setPrescriptionDetailValue={setPrescriptionDetailValue}
                        testPrescriptionValidity={testPrescriptionValidity}
                        placeholderText={Form.SelectPlaceholder}
                      />
                      <Select
                        defaultOptionText={Form.DefaultOption}
                        defaultOption={true}
                        minValue={25}
                        maxValue={45}
                        interval={0.5}
                        name={'pupillaryDistanceLeft'}
                        suffix={null}
                        fullWidth={false}
                        setPrescriptionDetailValue={setPrescriptionDetailValue}
                        testPrescriptionValidity={testPrescriptionValidity}
                        placeholderText={Form.SelectPlaceholder}
                      />
                    </div>
                  </div>
                </div>

                <div className="buttonGroup">
                  {/* Go back button */}
                  <a className="button button-outline button-block button-large prescriptionPopup_backButton"
                     href="#"
                     onclick={event => {
                       event.preventDefault()
                       previousStep()
                     }}>
                    &larr; {Button.GoBackText}
                  </a>
                  {/* Add to cart button */}
                  <AddToCartButton
                    buttonText={Button.AddToCartText}
                    disabled={!prescriptionValidity}
                    product={product}
                    selectedOption={selectedOption}
                    addCartItem={addCartItem}
                    prescriptionDetails={prescriptionDetails}
                    isPolarised={isPolarised}
                  />
                </div>

                <div className="prescriptionPopup_help">
                  {Support.ContactText} <a className="link" href={`mailto: ${Support.Email}`}>{Support.Email}</a>
                </div>

              </div>
              : ''
            }

          </div>
        </div>
      )
    }
  }
}

export {
  PrescriptionSelector,
  PrescriptionToggleButton
}
